import { Component, OnInit, ViewChild } from '@angular/core';
import { DataColumn } from '../../../models';
import { MatSidenav } from '@angular/material/sidenav';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DetailsComponent } from './details/details.component';
import { CandidatureStatusComponent } from './table-components/candidature-status/candidature-status.component';
import { CandidatureMissionComponent } from './table-components/candidature-mission/candidature-mission.component';
import { UserCandidatureComponent } from './user-candidature/user-candidature.component';
import { AuthService } from '../../../services/auth.service';
import { CandidatesApplied, Mission } from '../../../models/Mission';
import { MissionService } from '../../../services/mission.service';
import { debounceTime } from 'rxjs';
import { TableEnCourActionComponent } from '../missions/encour-component/components/table-en-cour-action/table-en-cour-action.component';
import { MissionDetailsComponent } from '../missions/encour-component/mission-details/mission-details.component';

@Component({
  selector: 'app-candidatures',
  templateUrl: './candidatures.component.html',
  styleUrl: './candidatures.component.scss',
})
export class CandidaturesComponent implements OnInit {
  // Define an array to hold the generated data
  randomData: PeriodicElement[] = [];
  offset: number = 0;
  size: number = 100;
  loading = false;
  // Define the custom columns array

  customColumns: DataColumn[] = [
    {
      header: 'Candidature',
      fieldName: 'firstname',
      dataType: 'component',
      component: UserCandidatureComponent,
      col: 'col',
    },
    {
      header: 'Note',
      fieldName: 'globalRating',
      dataType: 'string',
      cellWidth:'80px'
    },
    {
      header: 'Référence',
      fieldName: 'mission',
      dataType: 'component',
      component: CandidatureMissionComponent,
          col: 'col',
    },

    {
      header: 'Site',
      fieldName: 'site',
      dataType: 'string',
      col: 'col-1',
    },
    {
      header: 'Service d’affectation',
      fieldName: 'serviceAffectation',
      dataType: 'string',
          col: 'col',
    },
    {
      header: 'Poste',
      fieldName: 'typePoste',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Type de contrat',
      fieldName: 'typeContrat',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Dates',
      fieldName: 'duration',
      fieldNameStartDate: 'startdate',
      fieldNameEndDate: 'enddate',
      dataType: 'date',
      col: 'col',
    },
    {
      header: 'Rémunération',
      fieldName: 'compensationproposednet',
      fieldNameCurrency: 'currency',
      dataType: 'currency',
      col: 'col',
    },
    {
      header: 'Statut',
      fieldName: 'status',
      dataType: 'component',
     component: CandidatureStatusComponent,
    //  component: TableEnCourActionComponent,
      col: 'col',
      unClickable: true,
    },
  ];

  missions = new FormControl('');
  candidatureList: any[] = [];
  missionsList: any[] = [];
  formFilter: FormGroup;
  @ViewChild('sidenav') sidenav!: MatSidenav;

  constructor(
    private dialog: MatDialog,
    private missionService: MissionService,
    private fb: FormBuilder,
    private auth: AuthService
  ) {
    this.formFilter = this.fb.group({
      adresseId: null,
      endDate: [''],
      missionTitle: [''],
      page: this.offset,
      size: this.size,
      startDate: [''],
      statusOfCandidatOnMission: [[]],
    });
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.fetchCandidature();
    this.missionService.getRefreshMission().subscribe({
      next: () => {
        this.fetchCandidature();
      },
    });
    this.formFilter.valueChanges.pipe(debounceTime(700)).subscribe((res) => {
      this.fetchCandidature();
    });
  }

  fetchCandidature() {
    this.loading = true;

    this.missionService
      .getMissionsByEstablishmentId(this.formFilter.value, this.auth.id!)
      .subscribe({
        next: ({ content, totalItems }) => {
          this.candidatureList = [];
          this.missionsList = content;
          for (const mission of content) {
            if (mission.candidatesApplied) {
              mission.candidatesApplied.forEach(
                (candidature: CandidatesApplied) => {
                  if (
                    mission.typecontat === 'Liberal' ||
                    mission.typecontat === 'LIBERAL'
                  ) {
                    mission.typecontat = 'Intérim';
                  }
                  var globalRating = 'N/A';
                  if (candidature?.ratingCount && candidature?.ratingCount > 0)
                  {
                    globalRating = candidature?.ratingAvg + ' (' + (candidature?.ratingCount)+')';
                  }
                  candidature.globalRating = globalRating;
                  const item = {
                    candidature,
                    startdate: mission.startdate,
                    enddate: mission.enddate,
                    typeContrat: mission.typecontat,
                    missionTitle: mission.missionTitle,
                    serviceAffectation: mission.serviceAffectationsName,
                    site: mission?.adresseDto?.name,
                    typePoste: mission.typePoste,
                    address: '', //mission.adresseDto.adress,
                    secteur: mission.typeSecteur,
                    compensationproposednet: mission.compensationproposednet,
                    missionStatus: mission.missionStatus,
                    isUrgent: mission?.isurgent,
                    id: mission.id,
                    globalRating : globalRating
                  };
                  this.candidatureList.push(item);
                }
              );
            }
            // for (const candidature of content?.candidatesApplied) {
            //
            // }
          }

          this.loading = false;
        },
        error: (err) => {
          console.log(err);
          this.loading = false;
        },
      });
  }

  handleFullRowClick = (row: any) => {
    /*this.dialog.open(DetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: row,
      // animation: { to: "left" }
    });*/
    const dialog = this.dialog.open(MissionDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: row,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        this.fetchCandidature();
      }
    });
  };

  pagination(event: any) {}
}

export interface PeriodicElement {
  id: string;
  civility: string;
  firstname: string;
  lastname: string;
  mailadress: string;
  contractType: string;
  secteur: string;
  startDate: string;
  endDate: string;
  mission: Mission;
  status: string;
  renumeration: string;
  currency: string;
}
